<template>
  <div
    class="afterSale-container page-container"
    v-loading.lock="loading"
    element-loading-text="正在提交保存..."
  >
    <div class="afterSale-header">
      <img src="@/assets/imgs/logo.svg" alt="" />
      <h3>售后服务登记表</h3>
    </div>
    <div class="afterSale-main">
      <div class="afterSale-header-btn">
        <el-button class="gb-button" @click="$router.push({ path: '/o/d' })">
          进度查询
        </el-button>
      </div>
      <PerfectScrollbar>
        <div class="afterSale-wrap">
          <el-form
            label-width="120px"
            :model="params"
            label-position="top"
            @submit.native.prevent
            class="afterSale-form"
            ref="ruleForm"
            :rules="rules"
          >
            <div class="afterSale-wrap-left">
              <el-form-item label="设备型号" prop="modelSelect">
                <el-cascader
                  class="afterSale-cascader"
                  v-model="params.modelSelect"
                  :options="models"
                  clearable
                  filterable
                  placeholder="请输入设备型号"
                  popper-class="afterSale-cascader-popper"
                  :props="{ label: 'value' }"
                ></el-cascader>
              </el-form-item>
              <el-form-item label="姓名" prop="customer">
                <el-input
                  v-model="params.customer"
                  placeholder="请输入联系姓名"
                  class="afterSale-input"
                ></el-input>
              </el-form-item>
              <el-form-item label="手机" prop="phone">
                <el-input
                  v-model="params.phone"
                  placeholder="请输入联系手机"
                  class="afterSale-input"
                ></el-input>
              </el-form-item>
              <el-form-item label="地址" prop="customerInfo">
                <el-input
                  v-model="params.customerInfo"
                  placeholder="请输入联系地址"
                  class="afterSale-input"
                ></el-input>
              </el-form-item>
              <el-form-item label="故障描述" prop="issue">
                <el-input
                  v-model="params.issue"
                  placeholder="请详细描述您遇到的问题，如有多个问题，请分别列出"
                  type="textarea"
                  class="afterSale-input afterSale-textarea"
                ></el-input>
              </el-form-item>
              <el-form-item label="开机密码" prop="powerOnPass">
                <el-input
                  v-model="params.powerOnPass"
                  placeholder="请输入开机密码"
                  class="afterSale-input"
                ></el-input>
              </el-form-item>
              <el-form-item label="序列号" prop="sn">
                <el-input
                  v-model="params.sn"
                  placeholder="请输入序列号（序列号在产品外包装，保修卡，产品后壳位置）"
                  class="afterSale-input"
                ></el-input>
              </el-form-item>
              <el-form-item label="购买日期" prop="buyDate">
                <el-date-picker
                  v-model="params.buyDate"
                  type="date"
                  class="afterSale-input afterSale-date-picker"
                  placeholder="选择日期"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item>
                <p slot="label">
                  请提供设备正面、背面（含序列号）及问题描述的清晰图片。
                  <span class="el-form-item-tips">（最多5个文件）</span>
                </p>
                <el-upload
                  action=""
                  multiple
                  accept=".jpeg, .jpg, .png, .bmp, video/*"
                  :limit="5"
                  :auto-upload="false"
                  :on-change="handleChange"
                  :on-preview="handlePreview"
                  :on-remove="handleRemove"
                  :on-exceed="handleExceed"
                >
                  <el-button type="primary" size="default">
                    <i class="el-icon-plus"></i>文件上传</el-button
                  >
                </el-upload>
                <el-image
                  v-if="isPreview"
                  ref="imgPreview"
                  class="afterSale-imgPreview"
                  :src="url"
                  :preview-src-list="srcList"
                >
                </el-image>
              </el-form-item>
              <el-form-item class="afterSale-wrap-item" label="快递单号">
                <el-input
                  v-model="params.trackingNumber"
                  placeholder="为确保运送安全，建议使用顺丰,请勿到付！"
                  class="afterSale-trackingNumber-input"
                ></el-input>
              </el-form-item>
            </div>
            <div class="afterSale-wrap-right">
              <el-form-item label="送修地址：" class="afterSale-wrap-item">
                <div class="afterSale-companyInfo">
                  <p>联系人：文石售后维修</p>
                  <p>电话：4008-860-830</p>
                  <p>QQ客服：823903172</p>
                  <p>微信客服ID：booxonyx2009</p>
                  <div class="afterSale-companyInfo-qrCode">
                    <p>BOOX售后维修客服：</p>
                    <img src="@/assets/imgs/onlineCustomerService.png" alt="" />
                  </div>
                  <p>地址：广州市南沙区东涌镇市鱼路202号一楼（4号楼）</p>
                </div>
              </el-form-item>
              <el-form-item label="寄件需知：" class="afterSale-wrap-item">
                <div class="afterSale-tips">
                  <p>1、请返修前自行做好相关数据备份；</p>
                  <p>2、如配件没问题，请不要寄配件，以免遗失；</p>
                  <p>3、请将阅读器正面屏幕以及背面后壳拍照，并标注好联系人；</p>
                  <p>4、快件打包请注意保护好屏幕，避免运输中有损坏；</p>
                  <p>5、设备屏幕如有贴膜，如需换屏，屏膜将无法重贴；</p>
                  <p>6、寄送前请在包裹内附上包含姓名和手机的纸条，方便查询；</p>
                  <p>7、运费双方各支付一程，请勿寄到付，到付拒收；</p>
                </div>
              </el-form-item>
              <el-form-item class="afterSale-wrap-item">
                <el-button class="gb-button" @click="submitForm('ruleForm')">
                  提交
                </el-button>
              </el-form-item>
            </div>
          </el-form>
        </div>
      </PerfectScrollbar>
    </div>
  </div>
</template>

<script>
export default {
  name: "afterSaleCreate",
  computed: {
    rules() {
      let rules = {
        modelSelect: [
          { required: true, message: "设备型号不能为空", trigger: "change" },
        ],
        issue: [
          { required: true, message: "故障描述不能为空", trigger: "change" },
        ],
        sn: [{ required: true, message: "序列号不能为空", trigger: "change" }],
        phone: [
          { required: true, validator: this.checkphone, trigger: "change" },
        ],
        customer: [
          { required: true, message: "姓名不能为空", trigger: "change" },
        ],
        customerInfo: [
          { required: true, message: "地址不能为空", trigger: "change" },
        ],
      };
      return rules;
    },
  },
  data() {
    return {
      params: {
        mac: "",
        sn: "",
        model: "",
        modelSelect: [],
        salesChannel: "",
        buyDate: "",
        issue: "",
        customer: "",
        phone: "",
        customerInfo: "",
        trackingNumber: "",
        attachments: [],
        powerOnPass: "",
        store: "",
        source: "1",
        expired: null,
      },
      business: ["天猫", "京东", "其他", "线下实体"],
      fileArr: [],
      srcList: [],
      url: "",
      isPreview: false,
      buckets: null,
      ossClient: null,
      loading: false,
      models: [],
    };
  },
  methods: {
    checkphone(rule, value, callback) {
      // let phoneReg = /(^1[3|4|5|6|7|8|9]\d{9}$)|(^09\d{8}$)/;
      if (value == "") {
        callback(new Error("请输入手机号"));
      } else if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(value)) {
        callback(new Error("请输入正确的手机号!"));
      } else {
        callback();
      }
    },
    async getDevicesModelList() {
      let res = await this.$http.getDevicesModelList({
        sortBy: "updatedAt",
        limit: 100000,
      });
      this.models = this.setTreeNode(res.data);
    },

    setTreeNode(data) {
      let newGroup = {};
      for (let item of data.results) {
        if (!Object.keys(newGroup).includes(item.size)) {
          newGroup[item.size] = {
            label: item.size,
            value: item.size,
            children: [{ label: item.model, value: item.model }],
          };
        } else {
          newGroup[item.size].children.push({
            label: item.model,
            value: item.model,
          });
        }
      }

      return Object.values(newGroup).sort((a, b) => a.label - b.label);
    },
    handleChange(file, fileList) {
      this.fileArr = fileList;
      this.getImgsUrl();
    },
    handleRemove(file, fileList) {
      this.fileArr = fileList;
      this.getImgsUrl();
    },
    getImgsUrl() {
      this.srcList = [];
      for (let item of this.fileArr) {
        let format = item.name.split(".").pop();
        if (["jpeg", "jpg", "png", "bmp"].includes(format)) {
          this.srcList = [...this.srcList, URL.createObjectURL(item.raw)];
        }
      }
    },
    async handlePreview(file) {
      this.url = URL.createObjectURL(file.raw);
      this.isPreview = true;
      await this.$nextTick();
      this.$refs.imgPreview.clickHandler();
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 5 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.create();
        } else {
          return false;
        }
      });
    },

    async create() {
      try {
        this.loading = true;
        if (this.fileArr.length) {
          this.ossClient = await this.getOssClient();
          for (let item of this.fileArr) {
            this.params.attachments = [
              ...this.params.attachments,
              await this.fileUpload(item),
            ];
          }
        }
        this.params.model = this.params.modelSelect[1];
        await this.$http.createWorkorders(this.params);
        this.loading = false;
        this.elMsg(
          "你的售后维修表单已提交成功，我们会在收到快递包裹后尽快安排相关的维修，具体进度可在系统中查看!",
          "success",
          5000
        );
        this.$router.push({ path: "/o/d" });
      } catch (error) {
        this.loading = false;
        this.elMsg("提交失败", "error");
        console.log(error);
      }
    },

    fileUpload(item) {
      return new Promise(async (resolve, reject) => {
        try {
          let file = item.raw;
          let format = file.name.split(".").pop();
          let randomName = `upload/${this.randomString(
            6
          )}-${new Date().getTime()}.${format}`;

          let ret = await this.ossClient.multipartUpload(randomName, file);
          let url = ret.res.requestUrls[0].split("?")[0];
          resolve(url);
        } catch (error) {
          reject(error);
        }
      });
    },

    getOssClient() {
      return new Promise(async (resolve, reject) => {
        try {
          let buckets = await this.$http.getBuckets();
          this.buckets = buckets.data;
          let res = await this.$http.getOldSts();
          let { region, bucket } = this.buckets["onyx-log"];
          let creds = res.data;
          let client = new OSS({
            region,
            accessKeyId: creds.AccessKeyId,
            accessKeySecret: creds.AccessKeySecret,
            stsToken: creds.SecurityToken,
            bucket,
          });
          return resolve(client);
        } catch (error) {
          reject(error);
        }
      });
    },

    randomString(len) {
      len = len || 32;
      var chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
      var maxPos = chars.length;
      var pwd = "";
      for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },
  },
  mounted() {
    this.getDevicesModelList();
  },
};
</script>

<style lang="scss">
.afterSale-header {
  height: 66px;
  padding: 0 20px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  > img {
    width: 80px;
  }
}
.afterSale-main {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding-bottom: 10px;
  .afterSale-header-btn {
    display: flex;
    justify-content: flex-end;
    padding: 20px 10px;
  }
  .afterSale-wrap {
    flex: 1;
    display: flex;
    background: #fff;
    justify-content: center;
    padding: 20px 10px;
    margin: 0 10px;
    box-shadow: $div-shadow;
    overflow: hidden;
    border-radius: 4px;
    > .afterSale-form {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      > .afterSale-wrap-left,
      .afterSale-wrap-right {
        flex: 1;

        > .el-form-item {
          width: 100%;
          .el-form-item-tips {
            color: #ccc;
          }
          > .el-form-item__label {
            color: #292929;
            font-size: 16px;
            font-weight: bold;
          }
          .afterSale-trackingNumber-input {
            position: static;
          }
          .afterSale-input,
          .afterSale-trackingNumber-input {
            > input {
              height: 32px !important;
              line-height: 32px !important;
              border-radius: 4px;
              border: 1px solid #dcdfe6;
            }
          }
          .afterSale-textarea {
            > .el-textarea__inner {
              color: #292929;
              font-size: 14px;
              font-weight: 500;
            }
          }
          .afterSale-select,
          .afterSale-cascader {
            width: 220px;
            > .el-input {
              > input {
                height: 32px !important;
                line-height: 32px !important;
                border-radius: 4px;
                border: 1px solid #dcdfe6;
              }
            }
          }
          .afterSale-radio {
            > .el-radio__label {
              padding-left: 5px;
              vertical-align: middle;
            }
          }
          .afterSale-imgPreview {
            position: fixed;
            width: 20px;
            height: 20px;
            left: -1000px;
            top: -1000px;
          }
          .afterSale-companyInfo {
            color: #292929;
            font-size: 14px;
            font-weight: 500;
            letter-spacing: 1px;
            .afterSale-companyInfo-qrCode {
              /* display: flex; */
              > img {
                width: 100px;
                height: auto;
              }
            }
          }
          .afterSale-tips {
            @extend .afterSale-companyInfo;
          }
        }
        > .afterSale-wrap-item {
          > .el-form-item__content {
            position: static;
          }
        }
      }
    }
  }
}
.afterSale-cascader-popper {
  > .el-cascader-panel {
    > .el-cascader-menu:first-child {
      min-width: 140px !important;
    }
  }
}
</style>
